import { render, staticRenderFns } from "./QcSection.vue?vue&type=template&id=6ca5e883"
import script from "./QcSection.vue?vue&type=script&lang=js"
export * from "./QcSection.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports